import React from 'react';
import { Nav } from "react-bootstrap";
import { Badge } from '@mui/material';
import MenuItemsHelper from "../../../../store/helpers/MenuItemsHelper";


export default function SideBarNavigationTabAction(props) {
    const { partyHasRoleInContract, actions } = props;
    if (partyHasRoleInContract || (actions?.items && actions.items.length > 0)) {
        return (
            <Nav.Item className="nav-item">
                <Badge
                    overlap="rectangular"
                    badgeContent={actions.items?.length}
                    color={MenuItemsHelper.getBadgeColorForRAGColor(actions.RAGColor,"mui")}
                >
                    <Nav.Link eventKey={props.eventKey} className="nav-link show">
                        {props.title}
                    </Nav.Link>
                </Badge>
            </Nav.Item>
        );
    }
    else {
        return null;
    }
}